import { Button, Card, Toggle } from '@lilith-arcana-os/ui';

import type { UserPreferences } from '@lilith-arcana-os/domain';

interface SettingsFormProps {
  preferences: UserPreferences;
  onChange: (preferences: UserPreferences) => void;
  onSubmit: () => void;
  isSaving: boolean;
}

export function SettingsForm({ isSaving, onChange, onSubmit, preferences }: SettingsFormProps) {
  return (
    <Card eyebrow="Preferenze" title="Impostazioni utente">
      <div className="grid gap-4">
        <label className="grid gap-2 text-sm text-[var(--la-text-muted)]">
          Lingua
          <select
            className="rounded-2xl border border-white/10 bg-[rgba(10,10,15,0.9)] px-4 py-3 text-[var(--la-text)]"
            onChange={(event) =>
              onChange({
                ...preferences,
                language: event.target.value === 'en' ? 'en' : 'it',
              })
            }
            value={preferences.language}
          >
            <option value="it">Italiano</option>
            <option value="en">English</option>
          </select>
        </label>

        <div className="flex flex-wrap gap-3">
          <Toggle
            onPressedChange={(pressed) => onChange({ ...preferences, lilith_mode: pressed })}
            pressed={preferences.lilith_mode}
          >
            Lilith mode
          </Toggle>
          <Toggle
            onPressedChange={(pressed) =>
              onChange({ ...preferences, kabbalistic_overlay: pressed })
            }
            pressed={preferences.kabbalistic_overlay}
          >
            Kabbalah
          </Toggle>
          <Toggle
            onPressedChange={(pressed) =>
              onChange({ ...preferences, qliphotic_readings: pressed })
            }
            pressed={preferences.qliphotic_readings}
          >
            Qliphoth
          </Toggle>
          <Toggle
            onPressedChange={(pressed) => onChange({ ...preferences, show_audit_trail: pressed })}
            pressed={preferences.show_audit_trail}
          >
            Audit trail
          </Toggle>
        </div>

        <div>
          <Button disabled={isSaving} onClick={onSubmit}>
            {isSaving ? 'Salvataggio…' : 'Salva preferenze'}
          </Button>
        </div>
      </div>
    </Card>
  );
}
